import { Box, Button, Stack, Typography } from '@mui/material'
import { TrendingFlat } from '@mui/icons-material'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import BlockFullImage1Col from 'src/components/Common/BlockFullImage1Col'

export default function HeroMatrixGold310() {
  return (
    <BlockFullImage1Col
      dataGTM='The Efficiency Update'
      bgColor='#1f1c55'
      video='https://gemvision.com/Images/Hero_Home_3.10_BG.mp4'
    >
      <Stack sx={{ alignItems: 'center' }}>
        <Box
          component='img'
          alt='MatrixGold'
          sx={{ height: { xs: 16, sm: 24 }, mb: 4 }}
          src='https://gemvision.com/Images/MatrixGold/MatrixGold%20Light%20Registered.svg'
        />
        <Box
          component='img'
          alt='MatrixGold'
          sx={{ width: '100%', mb: 2 }}
          src='https://meteor.stullercloud.com/das/150652836?fmt=smart-alpha'
        />
        <Typography
          variant='h1'
          sx={{ fontWeight: 800, fontSize: { xs: '2.5rem', sm: '3rem', md: '3.5rem', wordBreak: 'break-word' } }}
        >
          <FormattedMessage id='home.hero.MG310.title' />
        </Typography>
        <Typography component='h2' sx={{ mt: 2, mb: 4, fontSize: { xs: '1.1rem', sm: '1.3rem', md: '1.3rem' } }}>
          <FormattedMessage id='matrixgold310.block1.subtitle' />
        </Typography>
        <Button
          data-gtm-click-subsection2='secondary-cta'
          variant='contained'
          size='large'
          component={Link}
          to='matrixgold/matrixgold-3'
          endIcon={<TrendingFlat />}
        >
          <FormattedMessage id='common.discoverNow' />
        </Button>
      </Stack>
    </BlockFullImage1Col>
  )
}
